import { useMemo } from 'react'

import { Item, ItemType } from '@inno-sdks/files'

import { allowedPrintableMimeTypes } from '../constants'

export const useItemVisibility = (item?: Item) =>
  useMemo(() => {
    const isFile = item?.type === ItemType.File

    return {
      shouldShowPreview: isFile,
      shouldShowDownload: isFile,
      shouldShowPrint: !!(
        isFile && allowedPrintableMimeTypes.includes(item.metaData.mimeType)
      )
    }
  }, [item])
